import map from 'lodash/map'
import React, { useContext, useEffect, useState } from 'react'

import { ProductTileWrapperMaxThree } from '@Components/ProductList/ProductTileWrapperMaxThree'
import { ProductTile } from '@Domains/Product/Tiles/Tile'
import { ProductSearchContext } from '@Globals/Algolia/Context'
import { MetadataContext } from '@Globals/Metadata'
import { useMediaQuery } from '@Globals/useMediaQuery'

export const ProductTilesList = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [enableHover, setEnableHover] = useState(false)
  const { storeURL } = useContext(MetadataContext)
  const { hitsArray } = useContext(ProductSearchContext)

  useEffect(() => { setEnableHover(isDesktop) }, [isDesktop])

  return (
    <ProductTileWrapperMaxThree>
      {map(hitsArray, (ref, index: number) => (
        <ProductTile
          key={ref.id}
          {...ref}
          enableHover={enableHover}
          priority={index < 20}
          sourceID="product_list"
          url={storeURL(ref.url)}
        />
      ))}
    </ProductTileWrapperMaxThree>
  )
}
